import React, { useState } from 'react'
import { useOrderStore } from 'src/hooks/order'
import Dropdown from 'src/component/Global/Dropdown'
import { InputWithDebounce } from "src/component/InputWithDebounce"

const ScheduleOrderReport = (props) => {
    const [{}, {}, { schedule_order_report }] = useOrderStore();
    const [reportName, setReportName] = useState('')
    const [reportFrequency, setReportFrequency] = useState('')
    const [includeOrdersFrom, setIncludeOrdersFrom] = useState('')
    const [selectedOrderStatuses, setSelectedOrderStatuses] = useState([])
    const [formErrors, setFormErrors] = useState({})
    const [submitting, setSubmitting] = useState(false)
    const [showFinalResult, setShowFinalResult] = useState(false)

    const statusOptions = props.statusOptions || [];
    const includeOrdersFromOptions = props.includeOrdersFromOptions || [];
    const reportFrequencyOptions = props.reportFrequencyOptions || []

    const handleSubmissions = async () => {
        setSubmitting(true)
        setFormErrors({})
        props.setEnableModalClosing(false)
        try {
            const form = {
                reportName: reportName,
                frequencyDays: reportFrequency,
                includeOrdersFromDays: includeOrdersFrom,
                orderStatuses: selectedOrderStatuses
            }

            const response = await schedule_order_report(form);
            if (response?.status !== 200) {
                if (response?.status === 422) {
                    const errors = {};
                    const fieldErrors = response?.data?.errors || [];
                    fieldErrors.map(fieldError => {
                        let errorMessage = fieldError.message;
                        const readableFieldName = fieldError.field.replace(/([a-z])([A-Z])/g, "$1 $2");
                        errorMessage = errorMessage.replace(fieldError.field, readableFieldName);
                        errors[fieldError.field] = errorMessage;
                    })
                    setFormErrors(errors);
                } else if (response?.status === 400) {
                    setFormErrors({ ReportName: response?.data?.Message || 'An error occurred. Please try again.' });
                }
            } else {
                setShowFinalResult(true);
            }
        } catch (error) {

        }

        setSubmitting(false);
        props.setEnableModalClosing(true);
    }

    const handleOrderStatusesChange = (data) => {
        const latestSelection = data[data.length - 1];
        if (latestSelection === 'All') {
            setSelectedOrderStatuses(['All']);
        } else {
            const filteredStatuses = data.filter(v => v !== 'All');
            if (filteredStatuses.length === statusOptions.length - 1) {
                setSelectedOrderStatuses(['All']);
            } else {
                setSelectedOrderStatuses(data.filter(v => v !== 'All'));
            }
        }
    }

    return (
        <>
            {
                <div id="order-report-modal">
                    <div className="bs5 modal-header border-0">
                        <h3 className="modal-title" id="exampleModalLabel">Schedule Order Report</h3>
                        <button
                            type="button"
                            className="close py-3"
                            data-dismiss="modal"
                            onClick={() => props.closeModal()}
                            disabled={!props.enableModalClosing}
                        >×</button>
                    </div>
                    {
                    !showFinalResult ? (
                        <>
                            <div className="modal-body allow-overflow">
                                <p><strong>Add details below to generate a schedule order report:</strong></p>

                                <div className="form-group">
                                    <label htmlFor="reportName">Report Name*</label>
                                    <InputWithDebounce
                                        id="reportName"
                                        className="form-control"
                                        type="text"
                                        placeholder="Enter Report Name"
                                        defaultValue={reportName}
                                        maxLength={100}
                                        onKeyUp={(value) => setReportName(value)}
                                    />
                                    { formErrors?.ReportName && <p className="error">{ formErrors?.ReportName }</p> }
                                </div>

                                <div className="form-group">
                                    <label htmlFor="reportFrequency">Report Frequency</label>
                                    <Dropdown
                                        defaultText="Select Frequency"
                                        id="reportFrequency"
                                        onDdlCallback={(value) => setReportFrequency(value)}
                                        ddlList={reportFrequencyOptions}
                                        label={"slug"}
                                        value={"key"}
                                        selectedValue={reportFrequency}
                                    />
                                    { formErrors?.ReportFrequency && <p className="error">{ formErrors?.ReportFrequency }</p> }
                                </div>

                                <div className="form-group">
                                    <label htmlFor="includeOrdersFrom">Include Orders From</label>
                                    <Dropdown
                                        defaultText="Select Time Period"
                                        id="includeOrdersFrom"
                                        onDdlCallback={(value) => setIncludeOrdersFrom(value)}
                                        ddlList={includeOrdersFromOptions}
                                        label={"slug"}
                                        value={"key"}
                                        selectedValue={includeOrdersFrom}
                                    />
                                    { formErrors?.IncludeOrdersFrom && <p className="error">{ formErrors?.IncludeOrdersFrom }</p> }
                                </div>

                                <div className="form-group">
                                    <label htmlFor="orderStatusField">Order Status*</label>
                                    <Dropdown
                                        defaultText="Select Status"
                                        id="orderStatusField"
                                        onDdlCallback={handleOrderStatusesChange}
                                        canSelectMultiple={true}
                                        ddlList={statusOptions}
                                        label={"slug"}
                                        value={"key"}
                                        selectedValue={selectedOrderStatuses}
                                        disabledValues={selectedOrderStatuses.includes('All') ? statusOptions.filter(o => o.key !== 'All').map(o => o.key) : []}
                                    />
                                    { formErrors?.OrderStatuses && <p className="error">{ formErrors?.OrderStatuses }</p> }
                                </div>
                            </div>
                            <div className="modal-footer d-flex justify-content-center">
                                <button
                                    type="button"
                                    className="bs5 btn btn-secondary"
                                    onClick={() => props.closeModal()}
                                    disabled={submitting}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="bs5 btn btn-primary"
                                    onClick={() => handleSubmissions()}
                                    disabled={
                                        submitting ||
                                        !reportName ||
                                        !reportFrequency ||
                                        !includeOrdersFrom ||
                                        !selectedOrderStatuses.length
                                    }
                                >
                                    Continue
                                </button>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="modal-body allow-overflow">
                                <div className='d-flex align-items-center gap-3'>
                                    <div className='success-check-circle'></div>
                                    <h4  className='m-0'><strong>Order Report Created!</strong></h4>
                                </div>

                                <div className='order-report-details-wrapper py-2 px-3 border border-secondary mt-4 mb-4 rounded'>
                                    <p><strong>{ reportName }</strong></p>

                                    <div className='schedule-report-row d-flex align-items-center gap-4 mb-3'>
                                        <div className='d-flex align-items-center gap-2'>
                                            <i className="m-0 d-flex align-items-center fa fa-lg fa-calendar"></i>
                                            <p className='m-0'>{ reportFrequencyOptions.find(option => option.key === reportFrequency)?.slug }</p>
                                        </div>

                                        <div className='d-flex align-items-center gap-2'>
                                            <i className="m-0 d-flex align-items-center fa fa-lg fa-clock-o"></i>
                                            <p className='m-0'>Orders from the { includeOrdersFromOptions.find(option => option.key === includeOrdersFrom)?.slug?.toLowerCase() }</p>
                                        </div>
                                    </div>

                                    <div className='schedule-report-row d-flex align-items-center gap-4'>
                                        <div className='d-flex align-items-center gap-2'>
                                            <i className="m-0 d-flex align-items-center fa fa-lg fa-flag"></i>
                                            <p className='m-0 text-secondary'>{ selectedOrderStatuses.map(value => { return statusOptions.find(option => option.key === value)?.slug }).join(', ') }</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer d-flex justify-content-center">
                                <button
                                    type="button"
                                    className="bs5 btn btn-primary"
                                    onClick={() => props.closeModal()}
                                    disabled={false}
                                >
                                    Close
                                </button>
                            </div>
                        </>
                    )
                    }
                </div>
            }
        </>
    )

}

export default ScheduleOrderReport
